import React from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {};

export const AccountChangeLoader = (props: Props) => {
    return (
        <div className={"AccountChangeLoader"}>
            <div className={"text-center"}>
                <OwLabel title={"loading"} leftIconClass={"fas fa-spin fa-refresh"} />
            </div>
        </div>
    );
};
